import { Disease } from './disease';


export interface EnvironmentDisease {
  allFoundations?: boolean;
  allFunds?: boolean;
  disease?: Disease;
  id?: number;
  name?: string;
  allFundsCount?: number;
  selectedFundsCount?: number;
  allFoundationsCount?: number;
  selectedFoundationsCount?: number;
}
